<template>
  <main class="container">
    <div class="checkmark">
      <CheckmarkIcon class="icon" />
    </div>

    <h1 class="page-title" data-testid="page-title">Good news!</h1>

    <p>
      It looks like all housemates have already joined the account for
      <span class="address">{{ address }}</span> so we can get started on
      setting up your utilities.
    </p>

    <router-link class="btn btn--big" to="/">Back Home</router-link>
  </main>
</template>

<script>
import CheckmarkIcon from "@/assets/svg/check.svg";
import { mapState } from "vuex";

export default {
  name: "AccountAlreadyComplete",
  computed: {
    ...mapState({
      address({ accountInformation }) {
        return accountInformation.address;
      },
    }),
  },
  created() {
    // ensure back btn is hidden
    this.$store.commit("HIDE_BACK_BTN");
  },
  components: {
    CheckmarkIcon,
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  max-width: 80rem;
}

.checkmark {
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background-color: $brand-orange;
  width: 100px;
  height: 100px;
  margin: 0 auto $spacing-large auto;

  .icon {
    fill: white;
    width: 60px;
    height: 100px;
  }
}

.address {
  font-weight: bold;
  color: $brand-orange;
}
</style>
